import React from 'react';
import { motion } from 'framer-motion';
import { FingerprintIcon, ShieldCheckIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
const reveal = {
  initial: {
    opacity: 0,
    y: 30
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-80px'
  },
  transition: {
    duration: 0.7
  }
};
export function Difference() {
  const {
    lang
  } = useLanguage();
  const isFR = lang === 'FR';
  const columns = [{
    Icon: FingerprintIcon,
    title: isFR ? "Une identité vérifiée, pas juste un assistant" : 'A verified identity, not just an assistant',
    body: isFR ? "La plupart ajoutent un assistant IA par-dessus des systèmes existants. BCITI fait fonctionner toute la ville sur une seule identité citoyenne vérifiée — la fondation que les autres n'ont pas." : 'Most bolt an AI assistant onto existing systems. BCITI runs the whole city on one verified citizen identity — the foundation others don’t have.'
  }, {
    Icon: ShieldCheckIcon,
    title: isFR ? "Vérifiée avant d'agir" : 'Verified before it acts',
    body: isFR ? "La plupart des plateformes génèrent une réponse. ATNA la vérifie avant de répondre — et la vérifie encore avant d'exécuter une action." : 'Most platforms generate an answer. ATNA verifies it before responding — and verifies again before executing an action.'
  }];
  return <section className="bg-white border-t border-[#E4E6EC] py-28 lg:py-36 px-6" data-id="element-242">
      {/* Header */}
      <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-243">
        <motion.div {...reveal} className="font-sans text-xs font-semibold tracking-[0.2em] text-[#4F46E5] uppercase mb-8" data-id="element-244">
          {isFR ? 'La différence' : 'The difference'}
        </motion.div>
        <motion.h2 {...reveal} transition={{
        duration: 0.7,
        delay: 0.05
      }} className="font-serif text-4xl md:text-5xl lg:text-[3.25rem] text-[#121212] leading-[1.12] tracking-tight mb-6" data-id="element-245">
          {isFR ? <>
              La plupart des plateformes répondent.
              <br data-id="element-246" />
              BCITI <span className="text-[#4F46E5]" data-id="element-247">vérifie</span>, puis agit.
            </> : <>
              Most platforms answer.
              <br data-id="element-248" />
              BCITI <span className="text-[#4F46E5]" data-id="element-249">verifies</span>, then acts.
            </>}
        </motion.h2>
        <motion.p {...reveal} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="font-sans text-lg md:text-xl text-[#121212]/60 leading-relaxed max-w-2xl mx-auto" data-id="element-250">
          {isFR ? "Deux choses qu'on ne copie pas : une identité vérifiée, et la vérification avant l'action." : 'Two things you cannot copy: a verified identity, and verification before action.'}
        </motion.p>
      </div>

      {/* Two columns */}
      <motion.div {...reveal} transition={{
      duration: 0.7,
      delay: 0.15
    }} className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 border border-[#E4E6EC] divide-y md:divide-y-0 md:divide-x divide-[#E4E6EC]" data-id="element-251">
        {columns.map(({
        Icon,
        title,
        body
      }) => <div key={title} className="p-8 md:p-10" data-id="element-252">
            <Icon className="w-6 h-6 text-[#4F46E5] mb-6" data-id="element-253" />
            <h3 className="font-serif text-2xl text-[#121212] mb-4 leading-snug" data-id="element-254">
              {title}
            </h3>
            <p className="font-sans text-base text-[#121212]/65 leading-relaxed" data-id="element-255">
              {body}
            </p>
          </div>)}
      </motion.div>
    </section>;
}